var Curriculog = Curriculog || {};

/**
 * A generic popup window
 *
 * Example Usage:
 *     var popup = new Curriculog.PopupWindow({url: '/somewhere'});
 *     popup.location() // returns "http://www.example.com/somewhere"
 *     popup.location('/somewhere_else');
 *     popup.close();
 */
Curriculog.PopupWindow = (function ($, _, Backbone, PopupWindow) {

    PopupWindow = Curriculog.CurriculogView.extend({
    /**
     * Backboneified popup window. Extend this to render a view in a popup window.
     *
     * @type {Backbone.View}
     */
    // Curriculog.PopupWindow = Backbone.View.extend({
        el: null,
        url: '',
        target: '_blank',

        // Window features
        toolbar: false,
        location: false,
        directories: false,
        status: false,
        menubar: false,
        scrollbars: true,
        resizable: true,
        copyhistory: false,
        width: 800,
        height: 500,
        top: null,
        left: null,

        initialize: function (options) {
            // _.extend(this, options);
            // this.window = this._popWindow();
            this.open(options);
            if (this.el) {
                this.render();
            }
        },

        /**
         * Opens a new popup window, closing any existing one.
         *
         * @param   {[Object]} options - any options that need to be overridden
         * @returns {Promise} - resolves when popup is loaded
         */
        open: function(options) {
            var defer = $.Deferred();

            _.extend(this, options || {});

            // close any existing window
            if (this.window) {
                this.close();
            }

            this.url = this.url || '';
            this.target = this.target || '_blank';

            // var feature_string = this.get_feature_string(this.features);
            this.window = window.open(this.url, this.target, this._features());

            $(this.window).on('load', defer.resolve);

            return defer.promise();
        },

        render: function () {
            var view = this;
            $(this.window.document.body).html(this.el);
            return this;
        },

        /**
         * Returns a boolean indicating whether the window is closed or not.
         *
         * @returns {Boolean}
         */
        isClosed: function() {
            return this.window && this.window.closed;
        },

        /**
         * Reloads the window.
         *
         * @returns {this} For chaining
         */
        reload: function() {
            this.window.location.reload();
            return this;
        },

        /**
         * Brings the window forward and into focus.
         *
         * @returns {this} For chaining
         */
        focus: function() {
            this.window.focus();
            return this;
        },

        /**
         * Used to get or set the window location
         *
         * @param   {[String]} href   - OPTIONAL: The new url to go to
         * @param   {[Object]} params - OPTIONAL: url parameter object that will be converted
         *                                to a string and appended to the url
         * @returns {String}          - If href is not given, returns the current location.
         */
        location: function(href, params) {
            // href given, set new location
            if (href !== undefined) {

                // if params is passed in, convert it to a string and append it to the url
                if (params !== undefined) {
                    href = endsWith(href, '?') ? href : href + '?';
                    href += $.param(params);
                }

                this.window.location.href = href;
                return href;
            }

            // No href given, return current location
            return this.window.location.href;
        },

        /**
         * Build the features object.
         * @return {String} a window.open feature string.
         */
        _features: function () {
            var defaults = _.pick(this, [
                'toolbar', 'location', 'directories', 'status', 'menubar',
                'scrollbars', 'resizable', 'copyhistory', 'width', 'height'
            ]);

            // Generate the 'top' and 'left' keys if they aren't defined.
            if (!defaults.left && !defaults.top) {
                defaults.left = ($(window).width() / 2) - (defaults.width / 2);
                defaults.top = ($(window).height() / 2) - (defaults.height / 2);
            }

            return this._featureString(defaults);
        },

        /**
         * Convert a features object to a Window.open feature string.
         */
        _featureString: function (obj) {
            var key, value, str = [];
            for (key in obj) {
                value = obj[key];
                // convert true/false values to yes/no
                if (value === true) {
                    str.push(key);
                    continue;
                } else if (value === false) {
                    value = 'no';
                }
                str.push(key + '=' + value);
            }
            return str.join(',');
        }
    });

    return PopupWindow;

})($, _, Backbone, Curriculog.PopupWindow || {});